const logger = (...messages) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(messages);
  }
};

export default logger;
